import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  computed:{
    ...mapGetters(['currentYear','selectedYear']),
  },
  methods: {
    ...mapActions(['getCycles']),
    ...mapMutations(['SET_YEAR']),
  },
  created(){
    if(this.currentYear !== this.selectedYear){
      this.SET_YEAR(this.currentYear)
      this.getCycles();
    }
  }
}
